<unity-modal
    title="Error"
    primaryAction="Close"
    (onPrimaryAction)="close()"
    (onClose)="close()">
    <ep-panel panelType="box" [title]="">
        <ep-row>
          <div class="table-responsive" style="margin: 10px">
            <table class="table" style="width: 100%">
              <tr>
                <th></th>
                <th *ngIf="error.objectType">Object Type</th>
                <th *ngIf="error.apiReplyCode">Reply Code</th>
                <th *ngIf="error.errorsToDisplay">Error</th>
                <th *ngIf="error.stack">Stack Trace</th>
                <th *ngIf="error.isAllowedToCopy"></th>
              </tr>
              <tr *ngIf="error">
                <td>
                  <unity-badge class="muted" [ngClass]="error.type == 'app' ? 'info ms-2' : 'warning ms-2'">
                    {{ error.badgeText }}
                  </unity-badge>
                </td>
                <td *ngIf="error.objectType">{{ error.objectType }}</td>
                <td *ngIf="error.apiReplyCode">{{ error.apiReplyCode }}</td>
                <td>
                  <ng-container *ngIf="error.errorsToDisplay">
                    <ng-container *ngFor="let message of error.errorsToDisplay">
                      <div>{{ message }}</div>
                    </ng-container>
                  </ng-container>
                </td>
                <td *ngIf="error.stack">{{ error.stack }}</td>
                <td style="padding-top: 15px" *ngIf="error.isAllowedToCopy">
                  <button unity-button
                    classes="icon-only icon-only-small"
                    ngbTooltip="Copy to Clipboard"
                    (click)="copyToClipboard(error)"
                  >
                    <svg class="unity-icon unity-icon-copy">
                      <use xlink:href="#unity-icon-copy"></use>
                    </svg>
                  </button>
                </td>
              </tr>
              <ng-container *ngIf="errors && errors.length > 0">
                <tr *ngFor="let error of errors">
                  <td>
                    <unity-badge class="muted info ms-2">
                      {{ error.badgeText }}
                    </unity-badge>
                  </td>
                  <td *ngIf="error.objectType">{{ error.objectType }}</td>
                  <td *ngIf="error.apiReplyCode">{{ error.apiReplyCode }}</td>
                  <td>
                    <ng-container *ngIf="error.errorsToDisplay">
                      <ng-container *ngFor="let message of error.errorsToDisplay">
                        <div>{{ message }}</div>
                      </ng-container>
                    </ng-container>
                  </td>
                  <td *ngIf="error.stack">{{ error.stack }}</td>
                  <td style="padding-top: 15px" *ngIf="error.isAllowedToCopy">
                    <button unity-button
                      classes="icon-only icon-only-small"
                      ngbTooltip="Copy to Clipboard"
                      (click)="copyToClipboard(error)"
                    >
                      <svg class="unity-icon unity-icon-copy">
                        <use xlink:href="#unity-icon-copy"></use>
                      </svg>
                    </button>
                  </td>
                </tr>
              </ng-container>
            </table>
          </div>
        </ep-row>
      </ep-panel>
</unity-modal>